<script setup>
import useStore from "./../store"
import FieldError from "./FieldError.vue"
import {storeToRefs} from "pinia";
import {computed, watch} from "vue";
import moment from "moment/moment";

const props = defineProps({
  errors: Array,
  removable: {
    type: Boolean,
    default: true
  },
  disabled: {
    type: Boolean,
    default: false
  },
  special: {
    type: Boolean,
    default: false
  },
  value: {
    type: [String, Number],
    default: 99,
  }
})

const store = useStore();
const emit = defineEmits(['hide', 'remove', 'setAttraction'])
const model = defineModel()
const productCode = defineModel('productCode')
const time = defineModel('time')



const filteredAttractions = computed(() => {
  return props.special ? store.attractions.filter(a => a.id === model.value) :
      store.attractions.filter(a => store.items.filter(i => i.attraction === a.id).length === 0 || a.id === model.value);
})

const remove = () => {
  if(window.confirm('Are you sure you want to remove this from your booking?')){
    emit('remove')
  }
}

const change = (e) => {
  const attractionId = parseInt(e.target.value);

  if (attractionId === 0) {
    model.value = attractionId
    productCode.value = false
    time.value = false

    return;
  }

  const attraction = store.attractions.find(a => a.id === attractionId)

  model.value = attraction.id
  productCode.value = attraction.rezdy_retail_product_code

  if (attraction.one_date?.active && attraction.one_date?.dateTime){
    time.value = moment(attraction.one_date.dateTime).format('YYYY-MM-DD HH:mm');
  } else {
    time.value = false;
  }

  if (window?.fathom && attraction?.code) {
    window.fathom.trackEvent('booking-select-' + attraction.code);
  }
}

const isWalkInOnlyToday = (attraction) => {
  const ranges = attraction?.walkin_only_dates ?? []
  if (!ranges.length) return false
  const today = moment()
  return ranges.some(range =>
      today.isBetween(moment(range.start), moment(range.end), 'day', '[]')
  )
}

const attractionLabel = (attraction) => {
  const label = attraction?.retail_title ?? attraction?.title ?? ''
  return isWalkInOnlyToday(attraction) ? `${label} (Walk-in Only)` : label
}

</script>
<template>
  <div class="attractions">
    <h3 class="font-bold text-footer text-xlx mb-2">Choose your experience</h3>
    <div class="pt-4 relative">
      <div class="flex gap-2">
        <select
            v-if="!props.disabled"
            @change="change"
            data-testid="booking-attraction-select"
            class="w-full rounded-full border bg-light border-light after:flex after:bg-blue-300 feature">
          <option :value="0" v-if="!props.special">-- Select Experience --</option>
          <option
              :selected="attraction.id === model"
              v-for="attraction in filteredAttractions"
              :key="attraction.id"
              :value="attraction.id"
              v-html="attractionLabel(attraction)"
          ></option>
        </select>
        <button
            v-if="removable"
            @click.prevent="remove"
            class="bg-light shrink-1 text-dark text-sm text-center p-2 px-4 rounded-full">Remove</button>
      </div>
      <FieldError :errors="props.errors" />
    </div>
  </div>
</template>
